import * as FFS from 'scripts/util/feature-flag/feature-flag.service';
import { EnvironmentConstants } from 'scripts/util/constants/environment.constants';

const FeatureFlagService = new FFS.FeatureFlagService(EnvironmentConstants.constants);

export default FeatureFlagService;
